<template>
<div class="chapter">
<div class="inner_page">
<p class="cip-break"><a id="pIV"></a>The Henry L. Stimson Lectures at the Whitney and Betty MacMillan Center for International and Area Studies at Yale.</p>
<p class="cip-spaced">Published with assistance from the Louis Stern Memorial Fund.</p>
<p class="cip-spaced">Copyright © 2018 by Susan Dunn.</p>
<p class="cip">All rights reserved.</p>
<p class="cip">This book may not be reproduced, in whole or in part, including illustrations, in any form (beyond that copying permitted by Sections 107 and 108 of the U.S. Copyright Law and except by reviewers for the public press), without written permission from the publishers.</p>
<p class="cip-spaced">Yale University Press books may be purchased in quantity for educational, business, or promotional use. For information, please e-mail <a class="www" href="mailto:sales.press@yale.edu">sales.press@yale.edu</a> (U.S. office) or <a class="www" href="mailto:sales@yaleup.co.uk">sales@yaleup.co.uk</a> (U.K. office).</p>
<p class="cip-spaced">Set in type by</p>
<p class="cip">Printed in the United States of America.</p>
<p class="cip-spaced">Library of Congress Control Number: 2017954129</p>
<p class="cip">ISBN 978-0-300-20353-0 (hardcover: alk. paper)</p>
<p class="cip-spaced">A catalogue record for this book is available from the British Library.</p>
<p class="cip-spaced">This paper meets the requirements of ANSI/NISO Z39.48-1992 (Permanence of Paper).</p>
<p class="cip-spaced">10 9 8 7 6 5 4 3 2 1</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// copyright.vue?2c2de08d